import React from "react";
import LeftPanel from "../../layouts/leftPanel/leftPanel";
import TopSearchBars from "../../layouts/topSearchBar/topSearchBar";
import MainContent from "../../layouts/mainContent/mainContent";
import "./dashboard.css";
import { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate, useSearchParams } from "react-router-dom";


const Dashboard = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const search = searchParams.get("search") || "";
    const category = searchParams.get("category") || "";

    const handleSelect = (name, category) => {
        navigate(`/dashboard?search=${encodeURIComponent(name)}&category=${encodeURIComponent(category)}`);
        // Set the category state
    };


    return (
        <div className="dashboard-container">
            {/* Search bar at the top */}
            <div className="dashboard-search-bar">
                <TopSearchBars onSelect={handleSelect} />
            </div>

            {/* Two sections below */}
            <div className="dashboard-content">
                <div className="dashboard-left-panel">
                    <LeftPanel />
                </div>
                <div className="dashboard-main-section">
                    <MainContent search={search} category={category} />
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
